module.exports = __webpack_public_path__ + "static/media/sch-logo.207def04.svg";